import { b as base } from "../../chunks/server.js";
import "../../chunks/url.js";
import "@sveltejs/kit/internal/server";
import "../../chunks/root.js";
import { redirect } from "@sveltejs/kit";
const load = async () => {
  redirect(307, `${base}/servers`);
};
export {
  load
};
